export default __webpack_public_path__ + "static/media/translate.b6f238a0.svg";